module.exports = __webpack_public_path__ + "static/media/carrierCompanyData.2ccdb0cb.png";